"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL = exports.TEXT = exports.TEL = exports.PASSWORD = exports.NUMBER = exports.EMAIL = exports.DATE = void 0;
/** @deprecated use exported type InputType instead */
exports.DATE = 'date';
/** @deprecated use exported type InputType instead */
exports.EMAIL = 'email';
/** @deprecated use exported type InputType instead */
exports.NUMBER = 'number';
/** @deprecated use exported type InputType instead */
exports.PASSWORD = 'password';
/** @deprecated use exported type InputType instead */
exports.TEL = 'tel';
/** @deprecated use exported type InputType instead */
exports.TEXT = 'text';
/** @deprecated use exported type InputType instead */
exports.URL = 'url';
